import { FC, forwardRef, useContext, useEffect, useState } from "react";
import { Delete } from "lucide-react";
import Image from "next/image";
import { Cross, PresetIcon } from "components/atoms/Icon";
import { DeleteConfirmationModal } from "components/molecules/DeleteModal";
import { AppContext } from "lib/contexts";
import { useDetectClickOut } from "lib/hooks";
import { AppReducerActionType, IPresetDTO } from "types";
import { Span } from "utils/styling/typography.styled";
import * as Styled from "./PresetSidebar.styled";
type SidebarProps = {
  presets: IPresetDTO[];
  onClick: (preset: IPresetDTO) => void;
  onDelete: (presetId: string) => Promise<void>;
};
export const SidebarContent = forwardRef<any, any>((props, ref) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedPresetId, setSelectedPresetId] = useState<string | null>(null);
  const handleDeleteClick = (presetId: string) => {
    setSelectedPresetId(presetId);
    setShowDeleteModal(true);
  };
  const handleConfirmDelete = async () => {
    if (selectedPresetId) {
      await props.onDelete(selectedPresetId);
      setShowDeleteModal(false);
      setSelectedPresetId(null);
    }
  };
  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedPresetId(null);
  };
  return <Styled.SidebarContainer ref={ref} $active={props.show}>
            <Styled.SidebarTitle>Presets</Styled.SidebarTitle>
            <Styled.PresetItemsContainer>
                {props.presets.map((preset: IPresetDTO) => <Styled.PresetItem key={preset.id} onClick={() => props.onClick(preset)}>
                        <Span>{preset.name}</Span>
                        <Styled.DeleteIcon onClick={e => {
          e.stopPropagation();
          handleDeleteClick(preset.id);
        }}>
                            <Delete />
                        </Styled.DeleteIcon>
                    </Styled.PresetItem>)}
            </Styled.PresetItemsContainer>

            {showDeleteModal && <DeleteConfirmationModal isOpen={showDeleteModal} onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} text="preset" />}
        </Styled.SidebarContainer>;
});
SidebarContent.displayName = "SidebarContent";
export const PresetSidebar: FC<SidebarProps> = ({
  presets,
  onClick,
  onDelete
}) => {
  const {
    state,
    dispatch
  } = useContext(AppContext);
  const {
    show,
    nodeRef,
    triggerRef
  } = useDetectClickOut(false);
  useEffect(() => {
    dispatch({
      type: AppReducerActionType.TOGGLE_OVERLAY_VISIBILITY,
      payload: {
        ...state,
        isOverlayVisible: show
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);
  return <>
            <Styled.SidebarToggle ref={triggerRef} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                {show ? <Image priority src={Cross} alt="Close Icon" /> : <Image priority src={PresetIcon} alt="Menu Icon" />}
            </Styled.SidebarToggle>
            <SidebarContent show={show} ref={nodeRef} presets={presets} onClick={onClick} onDelete={onDelete} data-sentry-element="SidebarContent" data-sentry-source-file="index.tsx" />
        </>;
};
PresetSidebar.displayName = "PresetSidebar";